import { render, staticRenderFns } from "./BeritaAdd.vue?vue&type=template&id=2898fd3d"
import script from "./BeritaAdd.vue?vue&type=script&lang=js"
export * from "./BeritaAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports